import { push } from '@lagunovsky/redux-react-router'
import cx from 'classnames'
import _ from 'lodash'
import moment from 'moment'
import { useDispatch } from 'react-redux'

import BadgeCinestar from '../../Badges/BadgeCinestar/BadgeCinestar'
import ButtonTime from '../../Buttons/ButtonTime/ButtonTime'
// import Icon from '../../Icon/Icon'

import './ProgramTime.scss'

// TODO: Investigate other event properties and title properties -> titulky, Dolby Atmos, ...
// THIS COMPONENT IS NOT USED

const ProgramTime = ({ className, data, disable, site }) => {
    const dispatch = useDispatch()
    const times = _.sortBy(data?.otherTimes, 'start') ?? []

    return (
        <div
            className={cx(
                'program-time d-flex justify-content-start align-items-center',
                className,
                disable && 'disable'
            )}
        >
            <div className={'text-formPrimary me-2'}>
                <div className={'d-flex align-items-center mb-1 gap-1'}>
                    {data?.event_properties?.map((property) => (
                        <BadgeCinestar key={`badge-${property}`} className={'my-auto px-2'}>
                            {property}
                        </BadgeCinestar>
                    ))}
                </div>
                {/* <div className="d-flex">
                    <Icon name={'subtitles'} className={'me-2'} />
                    <p className="program-time--sub m-0">Titulky</p>
                </div> */}
            </div>

            <div className={'program-time--options d-flex'}>
                {times.map(({ start, eventid }) => (
                    <ButtonTime
                        key={start}
                        time={moment(start).format('HH:mm')}
                        className={'mx-1'}
                        onClick={() => dispatch(push(`/?eventid=${eventid}&site=${site}`))}
                    />
                ))}
            </div>
        </div>
    )
}

export default ProgramTime
